import { BasicStructure, PreOrderData, PreOrderRequest, PreOrderValidationError } from "./Interfaces"

export const generateClearPreOrder = (): PreOrderData => {
    const result: PreOrderData = {
        Id: 0,
        Code: '',
        ClientName: '',
        ClientAddress: '',
        ClientIdentification: '',
        ClientPhoneNumber: '',
        CreatedBy: '',
        CreationDate: '',
        ModificationDate: '',
        Observation: '',
        ClientIdentificationType: 'Cédula de ciudadanía',
        ClientIdentificationTypeData: {
            Id: 'Cédula de ciudadanía',
            Name: 'Cédula de ciudadanía',
            Code: ''
          },
    }

    return result;
}

export const generateClearPreorderRequest = (): PreOrderRequest => {
    const result: PreOrderRequest = {
        CityId: 0,
        ClientAddress: '',
        ClientIdentification: '',
        ClientIdentificationType: 'Cédula de ciudadanía',
        ClientName: '',
        ClientPhoneNumber: '',
        CompanyId: 0,
        CreatedBy: '',
        ManagementId: '',
        Observation: '',
        ProductBrandId: 0,
        ProductTypeId: 0,
        StateId: 0
    }

    return result;
}

export const getIdentificationTypes = (): BasicStructure[] => {
    const identificationTypes: BasicStructure[] = [{
            Id: 'Cédula de ciudadanía',
            Name: 'Cédula de ciudadanía',
          },
          { Id: 'Nit', Name: 'Nit' },
          { Id: 'Pasaporte', Name: 'Pasaporte' },
          {
            Id: 'Cédula de extranjería',
            Name: 'Cédula de extranjería',
          },
          { Id: 'Otro', Name: 'Otro' },
    ];

    return identificationTypes;
}

export const generateClearPreOrderValidationErrors = (): PreOrderValidationError => {
    const result: PreOrderValidationError = {
        ClientIdentificationType: undefined,
        ClientIdentification: undefined,
        ClientName: undefined,
        ClientState: undefined,
        ClientCity: undefined,
        ClientAddress: undefined,
        ClientPhoneNumber: undefined,
        ClientEmail: undefined,
        ProductType: undefined,
        ProductBrand: undefined,
        ProductModel: undefined,
        ProductSerial: undefined,
        Observation: undefined,
    }

    return result;
}